<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in navItems"
            :key="item.key"
            class="ppv2-flex-1 ppv2-min-w-[200px] ppv2-max-w-[240px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="$emit('click', item.key)"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import StatsCard from '../Food/StatsCard.vue'
import { Tag } from 'lucide-vue'

export default {
    name: 'ResourceStatsNavigation',
    components: {
        StatsCard,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
            default: () => ({
                installations: 0,
                equipements: 0,
            }),
        },
        canConsultSalle: {
            type: Boolean,
            default: true,
        },
        canConsultMaterial: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        navItems() {
            return [
                {
                    key: 'installations',
                    countKey: 'installations',
                    label: this.$t('experiences.navigation.installations'),
                    icon: Tag,
                    show: this.canConsultSalle,
                },
                {
                    key: 'equipements',
                    countKey: 'equipements',
                    label: this.$t('experiences.navigation.equipements'),
                    icon: Tag,
                    show: this.canConsultMaterial,
                },
            ].filter((item) => item.show)
        },
    },
    methods: {
        normalizeSize,
    },
}
</script>
